/*
File Name: index.js
Created Date: 2020-05-27 08:36:44
Author: yeyong
Last modified: 2020-06-10 14:40:36
*/

export function formatDate(date) {
  var d = new Date(date)
  var month = "" + (d.getMonth() + 1)
  var day = "" + (d.getDate())
  var year = d.getFullYear()
  if (month.length < 2) {
    month = "0" + month
  }
  if (day.length < 2) {
    day = "0" + day
  }
  return [year, month, day].join("-")
}
export function formatTime(date) {
  var d = new Date(date)
  var hours = "" + d.getHours()
  var minutes = "" + d.getMinutes()
  var second = "" + d.getSeconds()
  if (hours.length < 2) {
    hours = "0" + hours
  }
  if (minutes.length < 2) {
    minutes = "0" + minutes
  }

  if (second.length < 2) {
    second = "0" + second
  }
  var time = [hours, minutes, second].join(":")
  return time
}

export function timeSince(date) {
  var d = new Date(date)
  var second = Math.floor((new Date() - date) / 1000);
  var interval = Math.floor(second / 31536000)
  interval = Math.floor(second / 60)
  return interval
}

const weeks = ['日', '一', '二', '三', '四', '五', '六']
export function chatTime(date) {
  if(!date){
    return ""
  }
  // console.log('chatTime:', date)
  const d = new Date(date)
  const t = new Date()
  const diff = t.getTime() / 1000 - d.getTime() / 1000
  // console.log('log chatTime:',diff,date,t)
  if (d.getYear() === t.getYear() && d.getMonth() === t.getMonth() && d.getDate() === t.getDate()) {
    return `${d.getHours()}:${d.getMinutes()}`
  } else if (diff < 604800) {
    return `周${weeks[d.getDay()]} ${d.getHours()}:${d.getMinutes()}`
  } else if (d.getFullYear() === t.getFullYear()) {
    return `${d.getMonth() + 1}-${d.getDate()} ${d.getHours()}:${d.getMinutes()}`
  }
  return `${[d.getYear(), d.getMonth() + 1, d.getDate()].join('-')} ${[d.getHours(), d.getMinutes()].join(':')}`
}
